import React, { useEffect, useMemo } from "react";
import { useAppDispatch } from "../../../redux/useAppDispatch";
import { Button, Form, Input, Modal, Radio, Spin } from "antd";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { fetchInprogressAudios, fetchRefreshInProgress, setIsEditedForDocumentInfoModal, updatePack } from "../../../redux/JobModule/InProgressPage/InProgressAction";

interface DocumentInfoModalProps {
  close: () => void;
  openState: boolean;
  open: () => void;
}

function DocumentInfoModal(props: DocumentInfoModalProps) {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();

  //Getting each pack Details
  const packDetails = useSelector((state: RootState) => state.InProgressAudiosState.packState.data);

  const Edited = useSelector((state: RootState) => state.InProgressAudiosState.packState.isEdited);

  // Loading state from redux slice
  const loading = useSelector((state: RootState) => state.InProgressAudiosState.packState.loading);
  //Populating the Form
  useEffect(() => {
    if (packDetails) {
      form.setFieldsValue({
        JobNumber: packDetails.jobNumber,
        Requestor: packDetails.clientName,
        Organization: packDetails.tenant,
        Priority: packDetails.packPriority,
      });
    } else {
      form.resetFields();
      console.warn("tenantDetails is undefined or null");
    }
  }, [packDetails, form]);

  //Modal Close Reseting the Fields
  const handleModalClose = () => {
    props.close();
    form.resetFields();
  };

  const DocumentModalInfoContent = useMemo(() => {
    const onFinish = async (value: any) => {
      // Prepare details object to be saved
      const details = {
        ...packDetails,
        jobNumber: value.JobNumber,
        clientName: value.Requestor,
        tenant: packDetails.tenant,
        packPriority: packDetails.packPriority,
      };
      await dispatch(updatePack({ packDetail: details, idPack: details.idPack }));
      handleModalClose();
      await dispatch(fetchRefreshInProgress({}));
    };

    return (
      <div className="d-flex flex-column gap-4 w-100 modal-body-content w-100">
        <h4> Edit Job</h4>

        <Form
          form={form}
          colon={false}
          name="documentInfoForm"
          layout="vertical"
          // labelCol={{ span: 8 }}
          // wrapperCol={{ span: 20 }}
          onFinish={onFinish}
          onValuesChange={() => {
            dispatch(setIsEditedForDocumentInfoModal(true));
          }}>
          <Form.Item
            className="form-item"
            label="Job Number"
            name="JobNumber"
            labelAlign="left"
            rules={[
              {
                required: true,
                message: "Please provide Job Number.",
              },
            ]}>
            <Input />
          </Form.Item>
          <Form.Item
            className="form-item"
            label="Requestor"
            name="Requestor"
            labelAlign="left"
            rules={[
              {
                required: true,
                message: "Please provide Requestor.",
              },
            ]}>
            <Input />
          </Form.Item>
          <Form.Item
            className="form-item"
            label="Organization"
            name="Organization"
            labelAlign="left"
            rules={[
              {
                required: true,
                message: "Please provide Organization.",
              },
            ]}>
            <Input disabled />
          </Form.Item>

          <Form.Item
            className="form-item"
            label="Priority"
            name="Priority"
            labelAlign="left"
            rules={[{ required: true, message: "Please select an Priority." }]}>
            <Radio.Group disabled>
              <Radio value="Standard">Standard</Radio>
              <Radio value="Express">Express</Radio>
            </Radio.Group>
          </Form.Item>

          <div className="d-flex gap-3 justify-content-end">
            <Button
              type="primary"
                className="button radius"
              disabled={Edited ? false : true}
              htmlType="submit">
              Save
            </Button>

            <Button
              className="cancelButton"
              htmlType="reset"
              onClick={handleModalClose}>
              Cancel
            </Button>
          </div>
        </Form>
      </div>
    );
  }, [form, packDetails, loading, Edited]);

  return (
    <div>
      <Modal
        centered
        zIndex={1500}
        footer={[]}
        loading={loading}
        width={400}
        onCancel={handleModalClose}
        open={props.openState}>
        {DocumentModalInfoContent}
      </Modal>
    </div>
  );
}

export default DocumentInfoModal;
